import {
    STATISTICS_CALENDAR_ROUTE,
} from './constants';

import http from '../../../utils/httpService';

/**
 *
 * @param calendarID
 */
const requestStatisticsCalendar = calendarID => {
    const route = STATISTICS_CALENDAR_ROUTE + `/${ calendarID }`;
    return http.request( route, 'GET' );
};

export {
    requestStatisticsCalendar
};